export default {
  checkClient() {
    const UA = navigator.userAgent;
    const rajax = /Rajax/i;
    const isXY = /EVE|Needle/i;
    const isQS = /QS|hbdteam/i;
    const isNapos = /Napos/i;
    const wechat = /MicroMessenger/i;
    const isIos = /iphone/i;
    const isIpad = /ios/i;
    const isAndroid = /android/i;

    if (wechat.test(UA)) return 'wechat';
    if (isXY.test(UA) && !rajax.test(UA)) return 'isXY';
    if (isQS.test(UA)) return 'isQS';
    if (isNapos.test(UA) && rajax.test(UA)) return 'isNapos';
    if (isIos.test(UA) || isIpad.test(UA)) return 'ios';
    if (isAndroid.test(UA)) return 'android';
    if (!isXY.test(UA)) return 'browser';
  },
  isXY() {
    return this.checkClient() === 'isXY';
  },
  isQS() {
    return this.checkClient() === 'isQS';
  },
  isNapos() {
    return this.checkClient() === 'isNapos';
  },
  isAndroid() {
    return this.checkClient() === 'android';
  }
};



// WEBPACK FOOTER //
// ./src/lib/userAgent.js